import { render, staticRenderFns } from "./DDate.vue?vue&type=template&id=1af097ec"
import script from "./DDate.vue?vue&type=script&lang=js"
export * from "./DDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports